import React, { Component } from 'react'
import styled from 'styled-components'
import Task from './Task'

const TaskContainer = styled.div`border: 1px solid black;`
const Button = styled.button`margin: 5px 0;`

export default class TasksTable extends Component {
  onChangeTask = (task, taskIndex) => {
    const { tasks, onChange } = this.props
    onChange([
      ...tasks.slice(0, taskIndex),
      task,
      ...tasks.slice(taskIndex + 1),
    ])
  }
  onDeleteTask = taskIndex => {
    const { tasks, onChange } = this.props
    onChange([...tasks.slice(0, taskIndex), ...tasks.slice(taskIndex + 1)])
  }
  onMoveTaskUp = taskIndex => {
    const { tasks, onChange } = this.props
    if(taskIndex > 0) {
      //logic - tasks.splice(toIndex, 0, tasks.splice(fromIndex, 1)[0])
      tasks.splice(taskIndex-1, 0, tasks.splice(taskIndex, 1)[0])
      onChange([...tasks])
    }
  }
  onMoveTaskDown = taskIndex => {
    const { tasks, onChange } = this.props
    if(taskIndex < tasks.length-1) {
      //logic - tasks.splice(toIndex, 0, tasks.splice(fromIndex, 1)[0])
      tasks.splice(taskIndex+1, 0, tasks.splice(taskIndex, 1)[0])
      onChange([...tasks])
    }
  }
  addTask = () => {
    const { tasks, onChange } = this.props
    onChange(tasks.concat({ mapping: [], task: '' }))
  }
  canDelete = (task, taskIndex) => {
    const hashes = item => /(#*)\s*(.*)/.exec(item)[1].length
    const nextTask = this.props.tasks[taskIndex + 1]
    return nextTask ? hashes(nextTask.task) <= hashes(task.task) : true
  }
  render() {
    const { tasks, mappingWhitelist } = this.props
    return (
      <div>
        <TaskContainer>
          {tasks.map((task, i) =>
            <Task
              key={i}
              index={i}
              task={task}
              onChange={this.onChangeTask}
              onDelete={this.onDeleteTask}
              onMoveUp={this.onMoveTaskUp}
              onMoveDown={this.onMoveTaskDown}
              canDelete={this.canDelete(task, i)}
              isLastItem={i === tasks.length-1}
              mappingWhitelist={mappingWhitelist}
            />,
          )}
        </TaskContainer>
        <Button onClick={this.addTask}>Add Task</Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/SummativePractical/TasksTable.js